import * as React from "react";
import {
    Card as MuiCard,
    Button,
    Typography,
    Box,
    Grid,
    OutlinedInput,
    InputAdornment,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
import { BackupOutlined, Search } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Controller, useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
function CreateChannel() {
    const classes = useStyles();
    const { singleProgram } = useSelector(
        (state: RootState) => state.programReducer
    );
    const { control, handleSubmit, errors, reset } = useForm();

    const community = singleProgram?.communities
    const onSubmit = async (data: any) => {
        try {
            //   data._id = user["_id"];
            //   await saveUserApi(data);
            //   user["name"] = data["name"];
            //   user["email"] = data["email"];
            //   user["lastName"] = data["lastName"];
            //   dispatch(updateProfile(user))
            //   toastr.success("Profile Updated Successfully");
            //   reset();
        } catch (error) {
            toastr.error("Failed to update team member. Please try again.");
            console.error("Error updating team member:", error);
        }
    };
    return (<>

        <div className={classes.container}>
            <MuiCard className={classes.card}>
                <Box className={classes.header}>
                    <Link to="/admin/channel">
                        <img src={backIcon} alt="Back" className={classes.backIcon} />
                    </Link>
                    <Box className={classes.logoWrapper}>
                        <img src={logo} alt="Logo" className={classes.logo} />
                    </Box>
                </Box>
                <Box >
                    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                        <Box>

                            <Typography variant="h3" className={classes.mainTitle} style={{ fontSize: '25px' }}>
                                Albertville First Nation
                            </Typography>
                            <Typography variant="h2"  style={{ color: "#000000",fontSize:'20px' }}>
                                Create post
                            </Typography>
                        </Box>

                        <Grid item xs={12} style={{ marginTop: '20px' }}>
                            <Typography variant="body1" className={classes.formLabel}  style={{ marginBottom: '8px' }}>
                                Select The Channel
                            </Typography>
                            <Controller
                                className={classes.textField}
                                variant="outlined"
                                name="channelName"
                                control={control}
                                rules={{
                                    required: "Name is required.",
                                }}
                                defaultValue=""
                                as={
                                    <OutlinedInput
                                        id="channelName"
                                        aria-describedby="name-helper-text"
                                        inputProps={{
                                            "aria-label": "channelName",
                                        }}
                                        labelWidth={0}
                                        placeholder="Healthy living channel"
                                        className={classes.inputStyle}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <Search style={{ cursor: "pointer" }} />
                                            </InputAdornment>
                                        }
                                    />
                                }
                            />
                            <ErrorMessage
                                as={<Typography color="error" />}
                                errors={errors}
                                name="channelName"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" className={classes.formLabel} style={{ marginBottom: '8px' }}>
                                Type of Information
                            </Typography>
                            <Controller
                                className={classes.textField}
                                variant="outlined"
                                name="specification"
                                control={control}
                                rules={{
                                    required: "Specification is required.",
                                }}
                                defaultValue=""
                                as={
                                    <OutlinedInput
                                        id="specification"
                                        aria-describedby="name-helper-text"
                                        inputProps={{
                                            "aria-label": "specification",
                                        }}
                                        labelWidth={0}
                                        placeholder="Post about warm weather benefits"
                                        className={classes.inputStyle}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <Search style={{ cursor: "pointer" }} />
                                            </InputAdornment>
                                        }
                                    />
                                }
                            />
                            <ErrorMessage
                                as={<Typography color="error" />}
                                errors={errors}
                                name="specification"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" className={classes.formLabel} style={{ marginBottom: '8px' }}>
                                Short description
                            </Typography>
                            <Controller
                                className={classes.textField}
                                variant="outlined"
                                name="specification"
                                control={control}
                                rules={{
                                    required: "Specification is required.",
                                }}
                                defaultValue=""
                                as={
                                    <OutlinedInput
                                        id="specification"
                                        aria-describedby="name-helper-text"
                                        inputProps={{
                                            "aria-label": "specification",
                                        }}
                                        labelWidth={0}
                                        placeholder="New road closures due to expanding wildfire"
                                        className={classes.inputStyle}
                                    />
                                }
                            />
                            <ErrorMessage
                                as={<Typography color="error" />}
                                errors={errors}
                                name="specification"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" className={classes.formLabel} style={{ marginBottom: '8px' }}>
                                Description
                            </Typography>
                            <Controller
                                className={classes.textField}
                                variant="outlined"
                                name="description"
                                control={control}
                                rules={{
                                    required: "Description is required.",
                                }}
                                defaultValue=""
                                as={
                                    <OutlinedInput
                                        id="description"
                                        aria-describedby="description-helper-text"
                                        inputProps={{
                                            "aria-label": "description",
                                        }}
                                        labelWidth={0}
                                        placeholder="Warm weather boosts mood and energy levels by increasing sunlight exposure, which promotes the production of serotonin. It also encourages outdoor physical activity, supporting overall health and well-being"
                                        multiline
                                        rows={4}
                                        className={classes.inputStyle}
                                    />
                                }
                            />
                            <ErrorMessage
                                as={<Typography color="error" />}
                                errors={errors}
                                name="description"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="body1" className={classes.formLabel} style={{ marginBottom: '8px' }}>
                                Upload more Images
                            </Typography>
                            <Controller
                                type="file"
                                className={classes.textField}
                                variant="outlined"
                                name="phoneNumber"
                                control={control}
                                rules={{
                                    required: "Phone Number is required.",
                                }}
                                defaultValue=""
                                as={
                                    <OutlinedInput
                                        id="phoneNumber"
                                        aria-describedby="last-name-helper-text"
                                        inputProps={{
                                            "aria-label": "phoneNumber",
                                        }}
                                        labelWidth={0}
                                        placeholder="Phone Number"
                                        className={classes.inputStyle}
                                        endAdornment={
                                            <BackupOutlined style={{ color: "#7CA0BB", cursor: "pointer" }} />
                                        }
                                    />
                                }
                            />
                            <ErrorMessage
                                as={<Typography color="error" />}
                                errors={errors}
                                name="phoneNumber"
                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            style={{ margin: "32px 0 8px 0" }}
                        >
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="large"

                                className={classes.submitBtn}
                            >
                                Create
                            </Button>
                        </Grid>
                    </form>
                </Box>
            </MuiCard>
        </div>
    </>
    );
}

export default CreateChannel;
